var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M10.2,0.1H1.8c-0.9,0-1.7,0.8-1.7,1.7v8.4c0,0.9,0.8,1.7,1.7,1.7h8.4c0.9,0,1.7-0.8,1.7-1.7V1.8 C11.9,0.9,11.1,0.1,10.2,0.1z M1.1,1.8c0-0.4,0.3-0.7,0.7-0.7h8.4c0.4,0,0.7,0.3,0.7,0.7v4.8L8.8,4.4C8.6,4.3,8.2,4.3,8,4.4 l-6.4,6.4c-0.3-0.1-0.5-0.3-0.5-0.7V1.8z M10.2,10.9H3l5.4-5.4L10.9,8v2.2C10.9,10.6,10.6,10.9,10.2,10.9z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M3.9,5.4c0.8,0,1.5-0.7,1.5-1.5S4.7,2.4,3.9,2.4S2.4,3.1,2.4,3.9S3.1,5.4,3.9,5.4z M3.9,3.4 c0.3,0,0.5,0.2,0.5,0.5S4.2,4.4,3.9,4.4S3.4,4.2,3.4,3.9S3.6,3.4,3.9,3.4z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.63f8b26a9c2b417d0a5f050351b7f882.svg";
export { ForwardRef as ReactComponent };